import React from 'react'

import getFields from 'apps/lib/getFields'

const type = 'group.new.regular'

const postDataAction = () => ({})

const summaryFields = getFields([
    {
        id: 'productOptionId',
        type: 'GroupNewRegular',
        required: true,
    },
])

const Summary = (props = {}) => summaryFields.map((Field) => (
    <Field
        key={props.id}
        {...props}
    />
))

export default {
    type,
    Summary,
    postDataAction,
}
